import { render } from "./ChartCard.vue?vue&type=template&id=3f434950&scoped=true&ts=true"
import script from "./ChartCard.vue?vue&type=script&lang=ts"
export * from "./ChartCard.vue?vue&type=script&lang=ts"

import "./ChartCard.vue?vue&type=style&index=0&id=3f434950&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f434950"]])

export default __exports__